import $ from 'jquery';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
import { dateFilterPlugin } from '@bingads-webui-campaign/projection-grid-date-filter';
import { inlineDownloadWithoutFilterstateAndSegmentPlugin } from '@bingads-webui-campaign/projection-grid-inline-download';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { performanceLogPlugin, perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { editablePlugin } from '@bingads-webui-campaign/projection-grid-editable';
import { showAdStrengthPlugin } from './show-ad-strength';

const appConfig = globalContext.require('component/config/index');
const appState = globalContext.require('component/state/index');
const edm = globalContext.requireDefault('component/edm-campaign/index');
const logger = globalContext.require('module/service/instrumentation/index');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/responsive-search-ad');
const s$i18n = globalContext.require('$/schema-i18n!campaign');
const s$AssetLink = globalContext.require('$/schema!campaign/AssetLink');
const { DownloadView } = globalContext.require('campaignui/feature/griddownload/view/adapter');

export function getPlugins({
  addDateChangeListener,
  p$daterange,
  perfMarker,
  scope,
  isForVNext,
}) {
  const ReportEmailRule = appState.get('$ReportEmailRule');
  appState.unset('$ReportEmailRule');

  return _.compact([{
    // For accurate grid init latency, PerfMarkerPlugin should be the first plugin to load.
    plugin: perfMarkerPlugin,
    config: { appConfig, marker: perfMarker },
  }, {
    plugin: a11yPlugin,
    config: { i18n },
  }, {
    plugin: dateFilterPlugin,
    config: {
      state: appState,
      isOdataActionSource: true,
      edm,
      addDateChangeListener,
      p$daterange,
      comparisonColumns: [],
    },
  }, {
    plugin: inlineDownloadWithoutFilterstateAndSegmentPlugin,
    config: {
      isAvailable: true,
      DownloadView,
      p$daterange,
      schema: s$AssetLink,
      gridId: 'RSAAssetsGrid',
      i18n,
      s$i18n,
      ReportEmailRule,
      processReportRule: ReportRule => _.defaults({
        Selection: _.defaults({
          AdId: Number(scope.adId),
        }, ReportRule.Selection),
      }, ReportRule),
    },
  }, {
    plugin: performanceLogPlugin,
    config: { appConfig, logger },
  }, {
    plugin: paginationPlugin,
    config: {
      availablePageSizes: [20, 50, 100, 200],
      enableRandomPage: false,
      pageNumberLabelText: isForVNext ? '' : i18n.getString('Grid_Page_Number_Label_Text'),
      pageSizeText: i18n.getString('Grid_ShowRows'),
      totalPageCountText: i18n.getString('Grid_PageOf'),
      resetPageNumberOnSort: true,
    },
  }, {
    plugin: uiBlockerPlugin,
    config: { el: $(isForVNext ? '.assets-page' : '#child-page') },
  }, {
    plugin: editablePlugin,
    config: { i18n },
  }, {
    plugin: showAdStrengthPlugin,
    config: {
      i18n,
      scope,
    },
  }]);
}
